import { UniverseReference } from '../types/commons';

export const UNIVERSES: Record<string, UniverseReference> = {
  MASSAGE: 'massage',
  BEAUTY: 'beauty',
  HAIRCUT: 'haircut',
  CLEANING: 'cleaning',
  CHILDCARE: 'childcare',
  SPORTS_COACHING: 'sports_coaching',
};

export const WELLNESS_UNIVERSES: UniverseReference[] = ['beauty', 'haircut', 'massage', 'sports_coaching'];

export const UNIVERSE_REFERENCES: UniverseReference[] = Object.values(UNIVERSES);

// TODO: Move this to a categories constants file
export const CATEGORIES = {
  MASSAGE: 'massage',
  MASSAGE_MAN: 'massage_man',
  MASSAGE_WOMAN: 'massage_woman',
  WOMAN: 'woman',
  CHILD: 'child',
  MAN: 'man',
  BODYCARE: 'bodycare',
  HAIR_REMOVAL: 'hair_removal',
  BABYSITTING: 'babysitting',
  RECURRING: 'recurring',
  AT_HOME_COACHING_60_MIN: 'at_home_coaching_60min',
  REMOTE_COACHING_40_MIN: 'remote_coaching_40min',
  REMOTE_COACHING_60_MIN: 'remote_coaching_60min',
};

export const HAIRCUT_COLOR_PRESTATIONS = [
  'woman_color',
  'woman_fullcolor',
  'tie_and_dye',
  'woman_streaks',
  'woman_hair_highlighting',
];

export const HANDS_NAIL_POLISH_PRESTATIONS = [
  'nail_polish',
  'manicure_and_nail_polish',
  'hands_gel_nail_polish',
  'artificial_nails_and_nail_polish',
];

export const FACE_CARE_PRESTATIONS = [
  'radiance_care',
  'purifying_care',
  'face_care_scrub',
  'face_care_anti_ageing',
  'face_care_moisturising',
];

export const SPORTS_COACHING_AT_HOME_CATEGORIES = [CATEGORIES.AT_HOME_COACHING_60_MIN];

export const SPORTS_COACHING_VISIO_CATEGORIES = [
  CATEGORIES.REMOTE_COACHING_40_MIN,
  CATEGORIES.REMOTE_COACHING_60_MIN,
];
